var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-layout-tabs"},_vm._l((_vm.options),function(item){return _c('LayoutButton',{key:item.key,attrs:{"active":_vm.innerValue === item.key,"size":_vm.size},on:{"click":function($event){return _vm.handleClick(item.key)}}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }